export const CUSTOM_LINK_TYPES = {
  1: 'SOCIAL_MEDIA_LINKEDIN',
  2: 'SOCIAL_MEDIA_FACEBOOK',
  3: 'SOCIAL_MEDIA_TWITTER',
  4: 'USER_DEFINED'
}

export const KB_USER_DEFINED_LINK_LIMIT = 4

export const customLinkDefault = { id: null, knowledgebaseId: '', createdAt: '', updatedAt: '', status: 'ACTIVE', displayText: '', url: '', type: CUSTOM_LINK_TYPES['4'] }

export const defaultSettings = {
  cnameDomain: '',
  googleAnalyticsCode: '',
  driftHelpDomain: '[company-name]',
  description: '',
  tagline: '',
  title: '',
  favicon: '',
  logo: '',
  mainColor: '#0A5BFF',
  isKBIndexed: true,
  selectedCustomLink: customLinkDefault,
  customLinks: []
}